// A floating pet that follows Sai around (and pulls in coins — see Level.magnetRadius).
import * as THREE from 'three';
import { petModel } from './models.js';
import { disposeObj } from './entities.js';

export class Pet {
  constructor(level, kind) {
    this.level = level;
    this.kind = kind;
    this.dead = false;
    this.model = petModel(kind);
    this.obj = new THREE.Group();
    this.obj.add(this.model);
    (level.group || level.scene).add(this.obj);
    this.t = Math.random() * 5;
    const p = level.player ? level.player.pos : new THREE.Vector3();
    this.obj.position.set(p.x - 1, p.y + (kind === 'dog' ? 0 : 1.6), p.z - 1);
    this.yaw = 0;
  }
  follow(dt, pos, facing) {
    this.t += dt;
    const side = Math.sin(this.t * 0.6) * 0.3;
    const ox = Math.sin(facing + 2.3) * (1.1 + side), oz = Math.cos(facing + 2.3) * (1.1 + side);
    let height = pos.y + 1.55 + Math.sin(this.t * 2.6) * 0.14;
    if (this.kind === 'dog') {
      height = pos.y;
      const world = this.level.world;
      if (world) for (let y = Math.floor(pos.y + 2); y >= Math.floor(pos.y - 4); y--) {
        if (world.solid(Math.floor(pos.x + ox), y, Math.floor(pos.z + oz))) { height = y + 1; break; }
      }
    }
    const target = new THREE.Vector3(pos.x + ox, height, pos.z + oz);
    const o = this.obj.position;
    const k = 1 - Math.exp(-5 * dt);
    const dx = target.x - o.x, dz = target.z - o.z;
    if (o.distanceTo(target) > 12) o.copy(target);
    else o.lerp(target, k);
    if (Math.hypot(dx, dz) > 0.05) this.yaw = Math.atan2(dx, dz);
    else this.yaw = facing;
    let d = this.yaw - this.obj.rotation.y;
    while (d > Math.PI) d -= Math.PI * 2;
    while (d < -Math.PI) d += Math.PI * 2;
    this.obj.rotation.y += d * Math.min(1, dt * 6);
    this.obj.rotation.z = this.kind === 'dog' ? 0 : Math.sin(this.t * 1.7) * 0.08;
    this.model.userData.legs?.forEach((leg, i) => { leg.rotation.x = Math.sin(this.t * 14 + (i === 0 || i === 3 ? 0 : Math.PI)) * Math.min(0.45, Math.hypot(dx, dz) * 0.4); });
    if (this.model.userData.tail) this.model.userData.tail.rotation.y = Math.sin(this.t * 9) * 0.55;
    this.model.userData.wings?.forEach((wing, i) => { wing.rotation.z = Math.sin(this.t * 7) * 0.5 * (i ? 1 : -1); });
    const rotors = this.model.userData.rotors;
    if (rotors) rotors.forEach((m, i) => (m.rotation.y += dt * (30 + i)));
    if (this.kind === 'dragon' && Math.random() < dt * 4 && this.level.fx) this.level.fx.particles.trail(o.clone().add(new THREE.Vector3(0, -0.3, 0)), 'fire', this.t);
    if (this.kind === 'ghost') this.model.children[0].material.opacity = 0.6 + Math.sin(this.t * 3) * 0.15;
  }
  update(dt) {
    const pl = this.level.player;
    if (!pl) return;
    this.follow(dt, pl.pos, pl.facing);
  }
  dispose() {
    this.obj.parent && this.obj.parent.remove(this.obj);
    disposeObj(this.obj);
  }
}
